import { DownloadButton } from "@/components/buttons/DownloadButton";
import { useDebouncedCallback } from "@mantine/hooks";
import { Collapse, Modal } from "antd";
import { MutableRefObject, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import styles from "./ScreeningResultsModal.module.scss";
export interface ScreeningResultModalRefs {
  items: MutableRefObject<null>;
}
const ScreeningResultsModal = ({
  tool,
  onClose,
  onRiskDownload,
  onExposureDownload,
  setRefs,
  isOpen
}: {
  tool?: string;
  onClose: () => void;
  onRiskDownload: () => void;
  onExposureDownload: () => void;
  setRefs?: (refs: ScreeningResultModalRefs) => void;
  isOpen: boolean;
}) => {
  const {
    t
  } = useTranslation();
  const {
    t: widgets
  } = useTranslation("widgets", {
    keyPrefix: "outputs"
  });
  const itemsRef = useRef(null);
  const handleRefsOnOpen = useDebouncedCallback(() => {
    if (!setRefs) {
      return;
    }
    setRefs({
      items: itemsRef
    });
  }, {
    delay: 300,
    flushOnUnmount: true
  });
  useEffect(() => {
    if (isOpen) handleRefsOnOpen();else itemsRef.current = null;
  }, [isOpen, itemsRef]);
  const items = [{
    key: "risk",
    label: <div>
          <div>{widgets("screen.title")}</div>
          <p className="text-xs">{widgets("screen.description")}</p>
        </div>,
    children: <DownloadButton onClick={onRiskDownload}>{t("actions:download.csv")}</DownloadButton>
  }, {
    key: "exposure",
    label: <div>
          <div>{widgets("exposures.title")}</div>
          <p className="text-xs">{widgets("exposures.description")}</p>
        </div>,
    children: <DownloadButton onClick={onExposureDownload}>{t("actions:download.csv")}</DownloadButton>
  }];
  return <Modal open={isOpen} destroyOnHidden onCancel={onClose} footer={null} title={`Screening Results - ${tool}`} className="pb-48" width={660} data-sentry-element="Modal" data-sentry-component="ScreeningResultsModal" data-sentry-source-file="ScreeningResultsModal.tsx">
      <div ref={itemsRef}>
        <Collapse accordion className={`${styles.collapse} w-full items-center bg-surface`} size="small" expandIconPlacement="end" items={items} data-sentry-element="Collapse" data-sentry-source-file="ScreeningResultsModal.tsx" />
      </div>
    </Modal>;
};
export default ScreeningResultsModal;